<template>
  <form name="customer" class="needs-validation" novalidate>
    <div id="alert" class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4" :class="alert.color"
      role="alert" v-if="alert.message">
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong><br />
      {{ alert.reason }}
    </div>
    <div class="alert m-alert m-alert--default mb-3 mt-4" role="alert">
      <h5><i class="fas fa-info-circle"></i> Informações do Cliente</h5>
    </div>
    <div class="row mb-2">
      <div class="col-md-2" v-if="data.id">
        <label>ID</label>
        <div class="input-group">
          <input type="text" class="form-control" placeholder="" v-model="data.id" readonly="readonly" />
        </div>
      </div>
      <div class="col-md-4">
        <label>Status</label>
        <div class="input-group">
          <SelectCustomerStatuses
            :selected="data.status"
            :disabled="!canManageCustomers"
            @change="onChangeStatus($event)"
          ></SelectCustomerStatuses>
        </div>
        <small class="modified_field" v-if="data.last_status_modification">Modificado por: {{
          data.last_status_modification.user.name }} às
          {{ data.last_status_modification.modified_at | datetime }}</small>

      </div>
      <div class="col-md-6">
        <div class="form-group" :class="{ 'has-danger': !data.status_reason }">
          <label>Motivo do status <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <SelectStatusReasons :first="'Selecione um motivo'" :status="data.status" :selected="data.status_reason"
              @change="data.status_reason = $event"></SelectStatusReasons>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-2" v-if="data.status != 1">
      <div class="col-md-8">
        <div class="form-group" :class="{
          'has-danger': !comment_status || !comment_status.trim().length,
        }">
          <label for="comment_status">Comentário do Status<span class="m--font-danger">*</span></label>
          <div class="input-group">
            <input type="text" id="comment_status" ref="comment_status" class="form-control m-input" placeholder=""
              v-model="comment_status" required />
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group" :class="{
          'has-danger': !pipedrive_id || !pipedrive_id.trim().length,
        }">
          <label for="pipedrive_id">ID do Pipedrive <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <input type="number" class="form-control m-input" name="pipedrive_id" id="pipedrive_id" ref="pipedrive_id"
              placeholder="" v-model="pipedrive_id" required />
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-md-6">
        <div class="form-group" :class="{ 'has-danger': !data.name }">
          <label for="name">Nome<span class="m--font-danger">*</span></label>
          <div class="input-group">
            <input type="text" id="name" ref="name" class="form-control m-input" placeholder="" v-model="data.name"
              required />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group" :class="{ 'has-danger': !data.cpf }">
          <label for="cpf">CPF <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <input type="text" class="form-control m-input" name="cpf" id="cpf" placeholder="" v-model="data.cpf"
              @keyup="this.searchCpf" v-mask="'###.###.###-##'" :readonly="data.id" required />
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-md-6">
        <div class="form-group" :class="{ 'has-danger': !data.size_id }">
          <label>Tamanho <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <SelectCustomerSizes :first="'Selecione um tamanho'" :selected="data.size_id"
              @change="data.size_id = $event" />
          </div>
          <small class="modified_field" v-if="data.last_size_modification">Modificado por: {{
            data.last_size_modification.user.name }} às
            {{ data.last_size_modification.modified_at | datetime }}</small>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group" :class="{ 'has-danger': !data.segment_id }">
          <label>Segmento <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <SelectCustomerSegments :first="'Selecione um segmento'" :selected="data.segment_id"
              @change="data.segment_id = $event" />
          </div>
          <small class="modified_field" v-if="data.last_segment_modification">Modificado por: {{
            data.last_segment_modification.user.name }} às
            {{ data.last_segment_modification.modified_at | datetime }}</small>
        </div>
      </div>

    </div>

    <div class="alert m-alert m-alert--default mb-3 mt-2" role="alert">
      <h5><i class="fas fa-dollar-sign"></i> Informações de cobrança</h5>
    </div>

    <div class="row mb-2">
      <div class="col-md-4">
        <label>Banco de Cobrança</label>
        <div class="input-group">
          <SelectBillingBanks :selected="data.omie_bank_id"
            @change="data.omie_bank_id = $event" />
        </div>
      </div>

      <div class="col-md-8">
        <div class="form-group" :class="{ 'has-danger': !data.email }">
          <label for="cpf">Email de cobrança <span class="m--font-danger">*</span></label>
          <div class="input-group">
            <input type="email" class="form-control m-input" name="email" id="email" placeholder="" v-model="data.email"
              required />
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-md-4">
        <div class="form-group" :class="{ 'has-danger': !data.business_executive_id }">
          <label>Executivo de negócios</label>
          <div class="input-group">
            <SelectBusinessExecutive :selected="data.business_executive_id"
              @change="data.business_executive_id = $event"></SelectBusinessExecutive>
          </div>
          <small class="modified_field" v-if="data.last_business_executive_modification">Modificado por:
            {{ data.last_business_executive_modification.user.name }} às
            {{
              data.last_business_executive_modification.modified_at | datetime
            }}</small>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Consultor CS</label>
          <div class="input-group">
            <SelectCustomerSuccess :selected="data.customer_success_consultant_id"
              @change="data.customer_success_consultant_id = $event"></SelectCustomerSuccess>
          </div>
          <small class="modified_field" v-if="data.last_customer_success_modification">Modificado por:
            {{ data.last_customer_success_modification.user.name }} às
            {{
              data.last_customer_success_modification.modified_at | datetime
            }}</small>
        </div>
      </div>

      <div class="col-md-4">
        <label for="start">Data do 1º acordo comercial</label>
        <div class="input-group">
          <input type="date" name="start" id="start" max="9999-12-31" class="form-control m-input"
            v-model="data.start" />
        </div>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-md-4">
        <label>Retenção de Imposto</label>
        <div class="input-group">
          <span class="m-switch m-switch--icon" title="Retenção de imposto">
            <label>
              <input type="checkbox" @change="!data.retention" name="retention" v-model="data.retention" />
              <span></span>
            </label>
          </span>
        </div>
      </div>
      <div class="col-md-4">
        <label>ERP Automatizado
          <i class="fas fa-info-circle info-icon"
            title="Ao gerar a ordem de serviço, irá também faturar a ordem de serviço na Omie"></i>
        </label>
        <div class="input-group">
          <span class="m-switch m-switch--icon" title="ERP Automatizado">
            <label>
              <input type="checkbox" @change="!data.is_automated" name="isAutomated" v-model="data.is_automated" />
              <span></span>
            </label>
          </span>
        </div>
      </div>
      <div class="col-md-4">
        <label>Faturamento Automatizado
          <i class="fas fa-info-circle info-icon"
            title="As faturas deste cliente serão enviadas para Omie de forma automática no começo do mês"></i>
        </label>
        <div class="input-group">
          <span class="m-switch m-switch--icon" title="Faturamento Automatizado">
            <label>
              <input type="checkbox" @change="!data.is_invoice_automated" name="isAutomated"
                v-model="data.is_invoice_automated" />
              <span></span>
            </label>
          </span>
        </div>
      </div>
    </div>

    <div class="alert m-alert m-alert--default mb-3 mt-5" role="alert">
      <h5><i class="fas fa-map-marker-alt"></i> Informações de endereço</h5>
    </div>

    <div class="row mb-3">
      <div class="col-md-4">
        <label for="cep">CEP</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="far fa-search"></i></span>
          </div>
          <input id="cep" type="text" class="form-control" placeholder="" v-model="address.cep" v-mask="'#####-###'"
            @keyup="cepSearch(address.cep)" />
        </div>
        <span class="m-form__help"></span>
      </div>
      <div class="col-md-8">
        <label>&nbsp;</label>
        <div class="alert alert-dismissible fade show m-alert--outline" :class="alertCep.color" role="alert">
          <i :class="alertCep.icon"></i> &nbsp;<strong>{{
            alertCep.message
            }}</strong><br />
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-12">
        <label for="address">Logradouro</label>
        <div class="input-group">
          <input id="address" type="text" class="form-control" placeholder="" v-model="address.logradouro" />
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-4">
        <label for="number">Número</label>
        <div class="input-group">
          <input id="number" type="text" class="form-control" placeholder="" v-model="address.numero" />
        </div>
      </div>
      <div class="col-md-8">
        <label for="type">Tipo</label>
        <div class="input-group">
          <input id="type" type="text" class="form-control" placeholder="" v-model="address.tipo" />
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-5">
        <label for="bairro">Bairro</label>
        <div class="input-group">
          <input id="bairro" type="text" class="form-control" placeholder="" v-model="address.bairro" />
        </div>
      </div>
      <div class="col-md-4">
        <label for="city">Cidade</label>
        <div class="input-group">
          <input id="city" type="text" class="form-control" placeholder="" v-model="address.cidade" />
        </div>
      </div>
      <div class="col-md-3">
        <label for="uf">UF</label>
        <div class="input-group">
          <input id="uf" type="text" class="form-control" placeholder="" v-model="address.uf" maxlength="2" />
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12">
        <label for="note">Observação do endereço</label>
        <div class="input-group">
          <input id="note" type="text" class="form-control" placeholder="" v-model="address.observacao" />
        </div>
      </div>
    </div>

    <div v-if="customerId === 'add'">
      <div class="alert m-alert m-alert--default mb-3 mt-5" role="alert">
        <h5><i class="fas fa-phone"></i> Informações de contatos</h5>
      </div>
      <div v-for="(contact, index) in contacts" :key="index">
        <div class="row mb-2">
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-6 mb-2">
                <input
                  type="text"
                  class="form-control form-control-sm mb-2"
                  placeholder="Nome do contato"
                  v-model="contact.name"
                />
                <input
                  type="tel"
                  class="form-control form-control-sm mb-2"
                  placeholder="Telefone"
                  v-model="contact.phone"
                />
                <select
                  class="form-control form-control-sm"
                  v-model="contact.type"
                >
                  <option value="">Selecione o tipo</option>
                  <option value="1">Outros</option>
                  <option value="2">Responsável pela plataforma</option>
                  <option value="3">Responsável financeiro</option>
                </select>
              </div>
              <div class="col-md-6">
                <input
                  type="text"
                  class="form-control form-control-sm mb-2"
                  placeholder="Email"
                  v-model="contact.email"
                />
                <input
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Cargo"
                  v-model="contact.post"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-8">
                <div class="m-form__group form-group">
                  <label for="">Recebe</label>
                  <div class="m-checkbox-inline">
                    <label class="m-checkbox">
                      <input type="checkbox" v-model="contact.report" /> Relatório
                      <span></span>
                    </label>
                    <label class="m-checkbox">
                      <input type="checkbox" v-model="contact.invoice" /> Fatura
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="m-form__group form-group">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger m-btn m-btn--custom mt-2"
                    @click="removeContact(index)"
                    v-b-tooltip.hover.left
                    title="Remover"
                  >
                    <i class="fal fa-trash-alt fa-lg"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-2 mb-4" />
      </div>
      <button
        type="button"
        class="btn btn-sm btn-success m-btn m-btn--custom mb-4"
        @click="addContact()"
      >
        <i class="fas fa-plus-circle"></i> Adicionar contato
      </button>
    </div>

    <hr class="row mt-5 mb-3" />
    <div class="row">
      <div class="col-md-12 text-right">
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.cpf.focus()" target="_self" class="m--font-danger"
            v-if="usedCpf"><strong>CPF</strong> já cadastrado *</a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.name.focus()" target="_self" class="m--font-danger" v-if="!data.name">O
            campo <strong>Nome</strong> é obrigatório *</a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.cpf.focus()" target="_self" class="m--font-danger" v-if="!data.cpf">O campo
            <strong>CPF</strong> é obrigatório *</a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.segment_id.focus()" target="_self" class="m--font-danger"
            v-if="!data.segment_id">O campo <strong>Segmento</strong> é obrigatório *</a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.business_executive_id.focus()" target="_self" class="m--font-danger"
            v-if="!data.business_executive_id">O campo <strong>Executivo de negócios</strong> é obrigatório *</a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.status.focus()" target="_self" class="m--font-danger"
            v-if="!data.status_reason">O campo <strong>Motivo do status</strong> é obrigatório *</a>
        </p>
        <p class="p-0 m-0" v-if="data.status != 1">
          <a href="#" @click.prevent="$refs.comment_status.focus()" target="_self" class="m--font-danger"
            v-if="!comment_status || !comment_status.trim().length">O campo <strong>Comentário do Status</strong> é
            obrigatório *</a>
        </p>
        <p class="p-0 m-0" v-if="data.status != 1">
          <a href="#" @click.prevent="$refs.pipedrive_id.focus()" target="_self" class="m--font-danger"
            v-if="!pipedrive_id || !pipedrive_id.trim().length">O campo <strong>ID do Pipedrive</strong> é obrigatório
            *</a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.size_id.focus()" target="_self" class="m--font-danger"
            v-if="!data.size_id">O campo <strong>Tamanho</strong> é obrigatório *</a>
        </p>
        <p class="p-0 m-0">
          <a href="#" @click.prevent="$refs.email.focus()" target="_self" class="m--font-danger" v-if="!data.email">O
            campo <strong>Email de cobrança</strong> é obrigatório *</a>
        </p>
        <p class="p-0 m-0" v-if="customerId === 'add'">
          <a
            href="#"
            target="_self"
            class="m--font-danger"
            v-if="!hasResponsavelFinanceiro"
            >É obrigatório cadastrar pelo menos 1 Contato <b>Responsável financeiro</b> com Nome, Email e Telefone</a
          >
        </p>
        <p class="p-0 m-0" v-if="customerId === 'add'">
          <a
            href="#"
            target="_self"
            class="m--font-danger"
            v-if="!hasResponsavelPlataforma"
            >É obrigatório cadastrar pelo menos 1 Contato <b>Responsável pela plataforma</b> com Nome, Email e Telefone</a
          >
        </p>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12 text-right">
        <button @click.prevent="saveForm()" class="btn" :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
          :disabled="!formIsValid">
          <i class="fas fa-save" v-if="formIsValid"></i>
          <i class="fas fa-exclamation-triangle" v-else></i>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import SelectCustomerSegments from '@/components/forms/SelectCustomerSegments';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';

import { baseApiUrl } from '@/global';
import axios from 'axios';
import SelectCustomerSizes from '@/components/forms/SelectCustomerSizes';
import { utilsMixin } from '@/mixins/utilsMixin';
import { validationMixin } from '@/mixins/validationMixin';
import { restrictedActionMixin } from '@/mixins/restrictedActionMixin.js';
import { mapActions } from 'vuex';
import SelectCustomerSuccess from '../forms/SelectCustomerSuccessConsultant';
import SelectBusinessExecutive from '../forms/SelectBusinessExecutive';
import SelectStatusReasons from '../forms/SelectStatusReasons';
import SelectCustomerStatuses from '../forms/SelectCustomerStatuses';
import SelectBillingBanks from '../forms/SelectBillingBanks';

export default {
  mixins: [returnMessageFormMixin, utilsMixin, validationMixin, restrictedActionMixin],
  name: 'CustomerSaveFormPhysical',
  components: {
    SelectCustomerStatuses,
    SelectStatusReasons,
    SelectBusinessExecutive,
    SelectCustomerSuccess,
    SelectCustomerSizes,
    SelectCustomerSegments,
    SelectBillingBanks,
  },
  data() {
    return {
      usedCpf: false,
      comment_status: '',
      pipedrive_id: '',
      contacts: [],
      CONTACT_TYPE_PLATAFORMA: '2',
      CONTACT_TYPE_FINANCEIRO: '3',
      address: {
        cep: '',
        logradouro: '',
        numero: '',
        bairro: '',
        cidade: '',
        uf: '',
        tipo: '',
        observacao: '',
      },
      data: {
        name: '',
        contract_type: 0,
        status: 1,
        status_reason: 'Novo cliente',
        segment_id: null,
        size_id: null,
        business_executive_id: null,
        customer_success_consultant_id: null,
        omie_bank_id: 1
      },
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      alertCep: {
        color: 'alert-metal',
        icon: 'fas fa-exclamation-triangle',
        message: 'Digite um cep para realizar uma busca.',
        reason: '',
      },
    };
  },
  methods: {
    addContact() {
      this.contacts.push({
        name: '',
        email: '',
        phone: '',
        post: '',
        type: '',
        report: false,
        invoice: false,
      });
    },
    removeContact(index) {
      this.contacts.splice(index, 1);
    },
    saveForm() {
      this.messageWaitingSave();
      this.$refs.name.focus();

      const { data } = this;

      data.address = this.address;
      data.pipedrive_id = this.pipedrive_id;
      data.comment_status = this.comment_status;
      
      if (this.customerId === 'add' && this.contacts.length > 0) {
        data.contacts = this.contacts.filter(
          contact => contact.name && contact.email && contact.phone
        );
      }

      const url = `${baseApiUrl}/v1/customer/save`;
      axios
        .post(url, data)
        .then((res) => {
          this.logMessageForm(res);
          this.data.id = res.data.item.id;
          this.$store.state.showCustomerSave = res.data.item.id;
          this.getDatas();
        })
        .catch((error) => this.logMessageFormFailed(error.response));
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/customer/data/${this.customerId}`;
      axios(url).then((res) => {
        if (res.data.status == 1 && !res.data.status_reason) {
          res.data.status_reason = 'Novo cliente';
        }

        this.data = { ...res.data.customerable, ...res.data };

        if (
          this.data.status_reason &&
          this.data.status_reason != 'Novo cliente'
        ) {
          this.data.status_reason = this.data.status_reason.status_reason;
        }
        if (res.data.documents) {
          this.data.cpf = res.data.documents.value;
          this.$store.state.showStatsCustomer = res.data.documents.type;
        }
        if (res.data.last_comment_status_modification) {
          this.comment_status = this.data.last_comment_status_modification.to;
        }
        if (res.data.last_pipedrive_id_modification) {
          this.pipedrive_id = this.data.last_pipedrive_id_modification.to;
        }

        if (this.data.address) {
          const address = JSON.parse(this.data.address);
          this.address = address[0];
        } else {
          this.address = {
            cep: '',
            logradouro: '',
            numero: '',
            bairro: '',
            cidade: '',
            uf: '',
            tipo: '',
            observacao: '',
          };
        }
      });
    },
    callData() {
      window.scrollTo(0, 0);
      this.getDatas();
    },
    cepSearch() {
      if (this.address.cep && this.address.cep.length > 8) {
        this.alertCep = {
          color: 'alert-primary',
          icon: 'fas fa-spinner fa-spin fa-lg',
          message: 'Buscando o cep...',
          reason: '',
        };

        const url = `https://viacep.com.br/ws/${this.address.cep}/json/`;
        axios
          .get(url, {
            transformRequest: [
              (data, headers) => {
                delete headers.common.Authorization;
                return data;
              },
            ],
          })
          .then((res) => {
            if (res.data.erro) {
              this.alertCep = {
                color: 'alert-danger',
                icon: 'fas fa-exclamation-triangle fa-lg',
                message: 'CEP não encontrado!',
                reason: '',
              };
            } else {
              this.address.logradouro = res.data.logradouro;
              this.address.bairro = res.data.bairro;
              this.address.cidade = res.data.localidade;
              this.address.uf = res.data.uf;
              this.alertCep = {
                color: 'alert-success',
                icon: 'fas fa-check fa-lg',
                message: 'CEP localizado!',
                reason: '',
              };
            }
          })
          .catch(function () {
            this.alertCep = {
              color: 'alert-danger',
              icon: 'fas fa-times-hexagon',
              message: 'Busca não realizada!',
              reason: '',
            };
          });
      }
    },
    onChangeStatus(status) {
      this.data.status = status;
      this.data.status_reason = '';
    },
    findCustomerCpf() {
      if (!this.validateCpf(this.data.cpf)) {
        this.logMessageFormWarning({
          data: {
            message: 'CPF inválido',
          },
        });
        return;
      }
      const url = `${baseApiUrl}/v1/customer/search/?page=1&cnpj=${this.data.cpf}`;
      this.usedCpf = false;
      axios
        .get(url)
        .then((res) => {
          if (res.data.total > 0) {
            this.logMessageFormWarning({
              data: {
                message: 'CPF já cadastrado!',
              },
            });
            this.usedCpf = true;
          }
        })
        .catch((error) => {
          this.logMessageFormFailed(error);
        });
    },
    ...mapActions(['searchCpf']),
  },
  computed: {
    customerId() {
      return this.$store.state.showCustomerSave;
    },
    hasResponsavelFinanceiro() {
      if (this.customerId !== 'add') return true;
      return this.contacts.some(
        contact => contact.type === this.CONTACT_TYPE_FINANCEIRO && 
                   contact.name && 
                   contact.email && 
                   contact.phone
      );
    },
    hasResponsavelPlataforma() {
      if (this.customerId !== 'add') return true;
      return this.contacts.some(
        contact => contact.type === this.CONTACT_TYPE_PLATAFORMA && 
                   contact.name && 
                   contact.email && 
                   contact.phone
      );
    },
    formIsValid() {
      if (this.data.status == 1) {
        if (
          this.data.name &&
          this.data.cpf &&
          this.data.segment_id &&
          this.data.business_executive_id &&
          this.data.status &&
          this.data.size_id &&
          this.data.status_reason &&
          !this.usedCpf &&
          this.data.email &&
          this.hasResponsavelFinanceiro &&
          this.hasResponsavelPlataforma
        ) {
          return true;
        }
        return false;
      }
      if (
        this.data.name &&
        this.data.cpf &&
        this.data.segment_id &&
        this.data.business_executive_id &&
        this.data.status &&
        this.data.size_id &&
        this.data.status_reason &&
        !this.usedCpf &&
        this.data.email &&
        this.comment_status &&
        this.comment_status.trim().length &&
        this.pipedrive_id &&
        this.pipedrive_id.trim().length &&
        this.hasResponsavelFinanceiro &&
        this.hasResponsavelPlataforma
      ) {
        return true;
      }
      return false;
    },
    customerStats() {
      return this.$store.state.showStatsCustomer;
    },
  },
  beforeMount() {
    if (
      this.customerId &&
      this.customerId !== 'add' &&
      this.customerStats === 'cpf'
    ) {
      this.callData();
    }
  },
  mounted() {
    this.searchCpf = this.debounce(this.findCustomerCpf, 1000);
  },
};
</script>
